import { Observable } from 'rxjs';
import { IConnectionState } from '../../core';
import type { StateSubjectRefresher } from '../../rxjs-utils';

import { ConnectionHelperService } from '../services/connection-helper.service';

export function connectionStateRefresherFactory(
	helperService: ConnectionHelperService
): StateSubjectRefresher<IConnectionState> {
	return (): Observable<IConnectionState> => helperService.checkConnectionState();
}
